<template>
    <div class="cs4-trial-profileFeed">
        <div class="cs4-selectOneMedia" v-if="isMediaSelected() && !isFirstMediaClicked" v-html="dictionaryFile.youCanSelectOnlyOneMedia"></div>
        <div class="cs4-profilePhotos" v-if="userInfo && userInfo.medias && userInfo.medias.length !== 0">
        <div class="cs4-productCrossImageWrapper"  v-for="(media, index) in userInfo.medias" :key="media.image" v-on:click="onMediaClick(media, index)">
            <div :class="getProductCrossCoverClass(media)" v-if="isMediaSelected()">
                <img :src="getProductCrossImageCover(media)" alt="" :class="getProductIconClassFor(media)" >
                <span v-if="media.videoUrl === selectedMedia.videoUrl">+{{dictionaryFile.trialQuantity}}</span> 
            </div>
            <img class="cs4-productCrossImage" :src="media.image" alt="" >
        </div>
    </div>
    </div>
</template>

<script>
export default{
    name: 'ProfileFeed',
    props: {
        dictionaryFile: {
            type: Object,
            required: true
        },
        userInfo: {
            type: Object,
            required: false
        },
    },
    emits: [
    ],
    data: function(){
        return {
            medias: [],
            selectedMedia: null,
            isFirstMediaClicked: null
        }
    },
    methods: {
        onMediaClick(media,index){
            if(index === 0 ){
                this.isFirstMediaClicked = true;
                this.selectedMedia = this.medias[0];
                this.resetMediaScroll();
            } else {
                this.isFirstMediaClicked = false;
                this.selectedMedia = this.medias[0];
                this.resetMediaScroll();
            }
        },
        resetMediaScroll(){
            var mediaScroll = document.getElementsByClassName('cs4-profilePhotos')[0];
            mediaScroll.scrollTo({left: 0, behavior: 'smooth'});
        },
        getProductCrossCoverClass(inputMedia){
            if(this.selectedMedia){
                if(this.selectedMedia.videoUrl === inputMedia.videoUrl){
                    return 'cs4-productCrossImageCover';
                } else if( !this.isFirstMediaClicked && this.selectedMedia.videoUrl !== inputMedia.videoUrl){
                    return 'cs4-productCrossImageCover--lock';
                }
                return 'cs4-productCrossImageCover--hidden';
            }
        },
        isMediaSelected(){
            return !!this.selectedMedia;
        },
        getProductCrossImageCover(inputMedia){
            if(this.selectedMedia){
                if(this.selectedMedia.videoUrl === inputMedia.videoUrl){
                    return this.dictionaryFile.likeIcon;
                } else if(!this.isFirstMediaClicked){
                    return this.dictionaryFile.lockIcon;
                }
            }
        },
        getProductIconClassFor(media){
            if(this.selectedMedia.videoUrl === media.videoUrl){
                return 'cs4-productIcon';
            } else if(!this.isFirstMediaClicked){
                return 'cs4-productIcon--lock';
            }
        }
        },
    mounted: function(){
        this.medias = this.userInfo.medias;
    },
}
</script>

<style scoped>
.cs4-profilePhotos {
  display: flex;
  width: 100%;
  height: 235px;
  scroll-behavior: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: hidden;
  overflow-x: scroll;
  cursor: grab;
  padding: 0 25px;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  grid-column:1 / span 2;
}

.cs4-profilePhotos::-webkit-scrollbar {
    display: none;
}

img.cs4-productCrossImage {
    background-color: #F15B65;
    border-radius: 25px;
    cursor: pointer;
    width: 120px;
    height: 213px;
    margin-right: 10px;
}

.cs4-productIcon {
    width: 25px;
    height: 23px;
}

.cs4-productIcon--lock {
    width: 30px;
    height: 40px;
}

.cs4-productCrossImageWrapper {
    position: relative;
    min-width: 120px;
    height: 213px;
    display: block;
    margin: 8px 5px 0;
}

.cs4-productCrossImageCover {
    position: absolute;
    background-color: #32B9ECCC;
    width:121px;
    height: 214px;
    border-radius: 25px;
    border: 5px solid #9FE4F9;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin: -1px;
    flex-direction: column;
}
.cs4-productCrossImageCover--lock {
    position: absolute;
    background-color: rgba(241, 91, 101, 0.5);
    width:121px;
    height: 214px;
    border-radius: 25px;
    border: 5px solid rgba(241, 91, 101, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin: -1px;
    flex-direction: column;
}

.cs4-selectOneMedia {
    font-size: 13px;
    color: #F15B65;
    font-weight: 700;
}

.cs4-productCrossImageCover--hidden {
    display: none;
}
</style>